import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterContainerSection from './VeltCommentsSidebarV2FilterContainerSection/VeltCommentsSidebarV2FilterContainerSection';
var VeltCommentsSidebarV2FilterContainerSectionList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-container-v2-section-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterContainerSectionList.Section = VeltCommentsSidebarV2FilterContainerSection;
export default VeltCommentsSidebarV2FilterContainerSectionList;
